import { Router, NavigationEnd } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import {
    Component,
    Inject,
    ElementRef,
    OnInit,
    Renderer2,
    HostListener,
} from '@angular/core';
import { ROUTES } from './sidebar-items';
import { AuthService } from 'src/app/restaurent-management/core/service/auth.service';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { AppService } from 'src/app/app.service';
@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
    public sidebarItems: any[];
    showMenu = 'dashboard';
    showSubMenu = '';
    showSubSubMenu = '';
    public innerHeight: any;
    public bodyTag: any;
    listMaxHeight: string;
    listMaxWidth: string;
    userFullName: string;
    userImg: string;
    userType: string;
    headerHeight = 60;
    currentRoute: string;


    //shubhakar 17/11/2020
    RoleId: any;
    datas: any;
    LogoPath: any;
    PoweredByText: any;
    LogoText: any;
    public MenuArray: any[];
    Respdata: any;
    Modules: any;
    SubModules: any;
    RoleName: any;
    UserName: any;
    FirstName: any;
    LastName: any;
    rolepath: any;
    UserID:any;
    ExistingPassword:any;
    constructor(
        @Inject(DOCUMENT) private document: Document,
        private renderer: Renderer2,
        public elementRef: ElementRef,
        private router: Router,
        public http: HttpClient,
        public authservice: AuthService,
    ) {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                if (event.url.split('/')[1] === 'multilevel') {
                    this.showMenu = event.url.split('/')[1];
                } else {
                    this.showMenu = event.url.split('/').slice(-2)[0];
                }
                this.showSubMenu = event.url.split('/').slice(-2)[0];
            }
        });
    }
    @HostListener('window:resize', ['$event'])
    windowResizecall(event) {
        this.setMenuHeight();
        this.checkStatuForResize(false);
    }
    @HostListener('document:mousedown', ['$event'])
    onGlobalClick(event): void {
        if (!this.elementRef.nativeElement.contains(event.target)) {
            this.renderer.removeClass(this.document.body, 'overlay-open');
        }
    }
    sidebarHideInPOS() {
        if (this.router.url == '/allscreens/pos' || this.router.url == '/allscreens/kitchen') {
            return false
        }
        return true
    }

    callMenuToggle(event: any, element: any) {
        if (element === this.showMenu) {
            this.showMenu = '0';
        } else {
            this.showMenu = element;
        }
        const hasClass = event.target.classList.contains('toggled');
        if (hasClass) {
            this.renderer.removeClass(event.target, 'toggled');
        } else {
            this.renderer.addClass(event.target, 'toggled');
        }
    }
    callSubMenuToggle(event: any, element: any) {
        if (element === this.showSubMenu) {
            this.showSubMenu = '0';
        } else {
            this.showSubMenu = element;
        }
    }
    ngOnInit() {
        this.RoleId = parseInt(JSON.parse(localStorage.getItem('UserDetails')).RoleID);
        this.UserName =  JSON.parse(localStorage.getItem('UserDetails')).UserName
        this.UserID=  parseInt(JSON.parse(localStorage.getItem('UserDetails')).UserID);
        this.FirstName=  JSON.parse(localStorage.getItem('UserDetails')).FirstName;
        this.LastName =  JSON.parse(localStorage.getItem('UserDetails')).Lastname;
        this.ExistingPassword =  JSON.parse(localStorage.getItem('UserDetails')).PassWord;

        this.getAllMenus();

    }


    getAllMenus() {
        this.MenuArray=[];
        this.MenuArray=[{
            path: '/welcome/home',
            title: 'Home',
            moduleName: 'dashboard',
            Id: '0',
            iconType: 'material-icons-two-tone',
            icon: 'home',
            class: '',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            submenu: [],
        },{
            path: '/koa/news-category',
            title: 'News Category',
            moduleName: 'news-category',
            Id: '0',
            iconType: 'material-icons-two-tone',
            icon: 'view_list',
            class: '',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            submenu: [],
        },{
            path: '/koa/news',
            title: 'News',
            moduleName: 'news',
            Id: '0',
            iconType: 'material-icons-two-tone',
            icon: 'dvr',
            class: '',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            submenu: [],
        },
        ,{
            path: '/koa/news-report',
            title: 'News Report',
            moduleName: 'news-report',
            Id: '0',
            iconType: 'material-icons-two-tone',
            icon: 'eco',
            class: '',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            submenu: [],
        },
        {
            path: '/koa/web-user',
            title: 'Web User',
            moduleName: 'web-user',
            Id: '0',
            iconType: 'material-icons-two-tone',
            icon: 'supervised_user_circle',
            class: '',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            submenu: [],
        },
        {
            path: '/koa/web-user-action',
            title: 'Web User Action',
            moduleName: '\web-user-action',
            Id: '0',
            iconType: 'material-icons-two-tone',
            icon: 'fact_check',
            class: '',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            submenu: [],
        }
    ];
        this.sidebarItems = this.MenuArray.filter((sidebarItem) => sidebarItem);
        
    }


    initLeftSidebar() {
        const _this = this;
        // Set menu height
        _this.setMenuHeight();
        _this.checkStatuForResize(true);
    }

    setMenuHeight() {
        this.innerHeight = window.innerHeight;
        const height = this.innerHeight - this.headerHeight;
        this.listMaxHeight = height + '';
        this.listMaxWidth = '500px';
    }

    isOpen() {
        return this.bodyTag.classList.contains('overlay-open');
    }
    checkStatuForResize(firstTime) {
        if (window.innerWidth < 1170) {
            this.renderer.addClass(this.document.body, 'ls-closed');
        } else {
            this.renderer.removeClass(this.document.body, 'ls-closed');
        }
    }
    mouseHover(e) {
        const body = this.elementRef.nativeElement.closest('body');
        if (body.classList.contains('submenu-closed')) {
            this.renderer.addClass(this.document.body, 'side-closed-hover');
            this.renderer.removeClass(this.document.body, 'submenu-closed');
        }
    }
    mouseOut(e) {
        const body = this.elementRef.nativeElement.closest('body');
        if (body.classList.contains('side-closed-hover')) {
            this.renderer.removeClass(this.document.body, 'side-closed-hover');
            this.renderer.addClass(this.document.body, 'submenu-closed');
        }
    }

    setModuleSubModuleId(Menu, SubMenu) {
        localStorage.setItem('ModuleId', Menu.Id);
        localStorage.setItem('SubModuleId', SubMenu.SubId);
        localStorage.setItem('SubModuleName', SubMenu.path);
        localStorage.setItem('leadmanagementbuy', "Menu");
    }
}   
